
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.427 9.229a.927.927 0 10-1.288.854v.592c0 .244.157.436.36.436.202 0 .359-.191.359-.436v-.592a.931.931 0 00.569-.854z"}}),_c('path',{attrs:{"d":"M12.42 6.568a.52.52 0 00-.487-.458c-.093-.005-.167-.024-.249-.037V4.279c0-1.458-.87-4.217-4.202-4.217-3.295 0-4.166 2.758-4.166 4.217v1.793c-.083.013-.157.032-.249.037a.521.521 0 00-.487.459c-.009.071-.789 7.127 4.808 8.358a.526.526 0 00.224 0c5.597-1.231 4.817-8.287 4.808-8.358zM4.358 4.281c.002-.325.107-3.176 3.163-3.176 3.014 0 3.118 2.851 3.12 3.174v1.278a1.336 1.336 0 01-.314-.628.522.522 0 00-.518-.454H5.236a.53.53 0 00-.514.433 1.435 1.435 0 01-.364.668V4.281zm3.142 9.6c-3.912-.942-3.99-5.397-3.917-6.784 1.179-.217 1.788-.971 2.04-1.579h3.789c.238.611.83 1.362 2.004 1.579.074 1.386-.004 5.841-3.916 6.784z"}})])
          )
        }
      }
    